import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Auth } from '../auth/auth';
import { PartnerContract } from '../models/partner.model';

/**
 * Estado del contrato del partner autenticado, derivado de Auth.infoProfile$.
 * Cualquier llamada a Auth.getProfile() (dashboard, perfil, mi ficha...) refresca
 * este estado automáticamente en toda la app, sin necesidad de notificarse entre sí.
 */
@Injectable({ providedIn: 'root' })
export class ContractStatusService {
  private readonly auth = inject(Auth);

  private readonly profile = toSignal(this.auth.infoProfile$, {
    initialValue: this.auth.infoProfile,
  });

  readonly contract = computed<PartnerContract | null>(
    () => this.profile()?.partner?.contract || null
  );

  readonly hasPendingSignature = computed(() => {
    const contract = this.contract();
    return !!contract && contract.status !== 'signed';
  });

  constructor() {
    this.ensureLoaded();
  }

  ensureLoaded(): void {
    if (!this.auth.isLoggedIn || this.auth.infoProfile) return;
    if (this.auth.currentUser?.roles?.includes('admin')) return;

    this.auth.getProfile().subscribe({ error: () => undefined });
  }
}
